import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  TextField,
  Autocomplete,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageUploader from "components/image-upload/ImageUploader";

const CourseOverview = ({
  overview,
  errors,
  setFieldValue,
  deleteCourse,
  id,
}) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col gap-8 items-center w-full px-20">
      <div className="w-1/2 flex flex-col gap-2">
        <TextField
          size="small"
          value={overview?.title || ""}
          onChange={(e) => setFieldValue("title", e.target.value)}
          fullWidth
          label={t("courses.title")}
          error={Boolean(errors?.title)}
          helperText={t(errors?.title)}
        />
        <TextField
          size="small"
          value={overview?.description || ""}
          onChange={(e) => setFieldValue("description", e.target.value)}
          fullWidth
          label={t("courses.desc")}
          error={Boolean(errors?.description)}
          helperText={t(errors?.description)}
          maxRows={6}
          multiline
        />
        <TextField
          size="small"
          value={overview?.writer || ""}
          onChange={(e) => setFieldValue("writer", e.target.value)}
          fullWidth
          label={t("articles.writer")}
          error={Boolean(errors?.writer)}
          helperText={t(errors?.writer)}
          maxRows={6}
          multiline
        />

        {/* Flex container for both Autocompletes */}
        <div className="flex gap-4">
          <Autocomplete
            disablePortal
            options={[
              "Պատմություն",
              "Աշխարհագրություն",
              "Հայոց Լեզու",
              "Իմ Հայրենիքը",
              "Գրականություն",
              "Հասարակագիտություն",
            ]}
            sx={{ width: 300 }}
            value={overview?.subject || ""}
            onChange={(e, value) => setFieldValue("subject", value)}
            renderInput={(params) => <TextField {...params} label="Առարկա" />}
          />

          {/* New Autocomplete with multiple choices */}
          <Autocomplete
            multiple
            disablePortal
            options={[
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
              "11",
              "12",
            ]}
            sx={{ width: 300 }}
            value={overview?.courseClass || []}
            onChange={(e, value) => setFieldValue("courseClass", value)}
            renderInput={(params) => <TextField {...params} label="Դասարան" />}
          />
        </div>
      </div>

      <div className="flex gap-10">
        <ImageUploader
          text={t("courses.cover")}
          image={overview?.images?.cover || ""}
          setImage={(file, url) =>
            setFieldValue("images", {
              ...overview.images,
              cover: file,
            })
          }
        />
        <ImageUploader
          text={t("courses.poster")}
          image={overview?.images?.poster || ""}
          setImage={(file, url) =>
            setFieldValue("images", {
              ...overview.images,
              poster: file,
            })
          }
        />
      </div>
      {id && (
        <Button
          color="error"
          variant="contained"
          onClick={() => {
            // deleteCourse();
            setOpen(true);
            // navigate("/courses");
          }}
        >
          Ջնջել Դասը
        </Button>
      )}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle> Հաստատում </DialogTitle>
        <DialogContent dividers>
          Դուք համոզված ե՞ք, որ դասը պետք է ջնջվի։
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={() => setOpen(false)}>
            Չեղարկել
          </Button>
          <Button
            onClick={() => {
              deleteCourse();
              setOpen(true);
              navigate("/courses");
            }}
          >
            Ջնջել
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CourseOverview;
